module.exports = __webpack_public_path__ + "img/Indodigi-description.e26622f8.webp";